export default "/_next/static/images/product-sms-22ea828ab696a20e6032437d18947de8.svg";